import React from 'react';
var qiYeWenHuaList = window.apiObj.qiYeWenHuaList
var qiYeWenHuaArray = []
qiYeWenHuaList.children.forEach((element,index) => {
  qiYeWenHuaArray.push({
    name: 'block0',
    className: 'block l5ru6wj6hkt-editor_css',
    md: 6,
    xs: 24,
    titleWrapper: {
      children: [
        {
          name: 'image',
          className: 'teams1-image',
          children:element.image,
        },
        {
          name: 'content',
          className: 'teams1-job l5ru8ygtwka-editor_css',
          children: (
            <span>
              <span>
                <span>
                  <p>{element.title}</p>
                </span>
              </span>
            </span>
          ),
        },
      ],
    }
  })
})
export const Feature70DataSource = {
  wrapper: {
    className: 'home-page-wrapper feature7-wrapper l5kp8hfix2n-editor_css',
  },
  page: { className: 'home-page feature7 l5kpczhzjkc-editor_css' },
  OverPack: { playScale: 0.3 },
  titleWrapper: {
    className: 'feature7-title-wrapper l5kp8nxln7-editor_css',
    children: [
      {
        name: 'title',
        className: 'feature7-title-h1',
        children: (
          <span>
            <p>关于融云</p>
          </span>
        ),
      },
      {
        name: 'content',
        className: 'feature7-title-content l5kp9fg9w29-editor_css',
        children: (
          <span>
            <p>About Us</p>
          </span>
        ),
      },
    ],
  },
  blockWrapper: {
    className: 'feature7-block-wrapper l5kp82t8nb-editor_css',
    gutter: 24,
    children: [
      {
        md: 6,
        xs: 24,
        name: 'block0',
        className: 'feature7-block',
        children: {
          className: 'feature7-block-group',
          children: [
            {
              name: 'image',
              className: 'feature7-block-image',
              children:
                'https://gw.alipayobjects.com/zos/basement_prod/e339fc34-b022-4cde-9607-675ca9e05231.svg',
            },
            {
              name: 'title',
              className: 'feature7-block-title',
              children: '身份证',
            },
            {
              name: 'content',
              className: 'feature7-block-content',
              children: '识别身份证正反面姓名、身份证号、发证机关等相关信息',
            },
          ],
        },
      },
    ],
  },
};
export const Teams10DataSource = {
  wrapper: { className: 'home-page-wrapper teams1-wrapper' },
  page: { className: 'home-page teams1' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <span>
              <p>{ window.apiObj.qiYeWenHuaList.title||'公司团建'}</p>
            </span>
          </span>
        ),
      },
    ],
  },
  block: {
    className: 'block-wrapper',
    children: qiYeWenHuaArray,
    
  },
};
